import styled from 'styled-components';
import { MSocialGroupOrientation } from './MSocialGroup.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

const isVertical = (orientation?: MSocialGroupOrientation) => orientation === MSocialGroupOrientation.Vertical;

export const Wrapper = styled.div<{
  orientation?: MSocialGroupOrientation;
}>`
  display: flex;
  flex-direction: ${({ orientation }) => (isVertical(orientation) ? 'column' : 'row')};
  align-items: ${({ orientation }) => (isVertical(orientation) ? 'flex-start' : 'baseline')};
  margin-bottom: ${spacers?.spacers?.[3] ?? '1rem'};
`;

export const IconsContainer = styled.div<{
  orientation?: MSocialGroupOrientation;
}>`
  > *:not(:first-child) {
    margin-left: ${spacers?.spacers?.[3] ?? '1rem'};
  }
  margin-left: ${({ orientation }) => (isVertical(orientation) ? '0' : spacers?.spacers?.[3] ?? '1rem')};
`;
